import { render, staticRenderFns } from "./ReviewPanel.vue?vue&type=template&id=2a9f2ca9&scoped=true&"
import script from "./ReviewPanel.vue?vue&type=script&lang=js&"
export * from "./ReviewPanel.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPanel.vue?vue&type=style&index=0&id=2a9f2ca9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9f2ca9",
  null
  
)

export default component.exports